export default __webpack_public_path__ + "static/footerlogo-8caf8b7b3d83c1503c0aeff7df73d9e2.png";